// eslint-disable-next-line import/no-duplicates
import {startReactClientHydration} from '@aboutyou/bootstrap/client';
import {Log} from '@aboutyou/mlm';
import {App} from './app/App';
import {LegacyRootProvider} from './bridge/LegacyRootProvider';

try {
  startReactClientHydration({
    components: {
      LegacyRootProvider,
      App,
    },
  });
} catch (error) {
  Log.error('@aboutyou/application-desktop', 'BootstrapCrashed', {error});
}
